module.exports = __webpack_public_path__ + "media/images/icon-sort-inactive-18ab3bbf72e2c27b3ec5eec4f711d145.png";